import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MdDialogRef } from '@angular/material'

import { ReportOption } from '../shared/report-option.enum'

@Component({
  selector: 'cm-report-options-dialog',
  templateUrl: './report-options-dialog.component.html',
  styleUrls: ['./report-options-dialog.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportOptionsDialogComponent implements OnInit {

  public reportOption = ReportOption
  public selectedOption = null

  constructor(private dialogRef: MdDialogRef<ReportOption>) {

  }

  ngOnInit() {
  }

  selectReportOption() {
    this.dialogRef.close(this.selectedOption)
  }
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/profile/report-options-dialog/report-options-dialog.component.ts